// @ts-nocheck
import React from 'react';
import { overhaulTypeApi } from '../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';
export default selectProps => <AutocompleteSelect placeholder="Выберите вид работ" fetch={async params => {
  return await overhaulTypeApi.fetch({
    ...selectProps.filter,
    ...params
  });
}} fetchSingle={overhaulTypeApi.get} notFoundText="Работы не найдены" renderOption={(overhaulType, Option) => <Option key={overhaulType.id} value={overhaulType.id}>
        {`${overhaulType.vehicleModelName} ${overhaulType.vehicleIssueGroupName}`}
      </Option>} {...selectProps} />;
